<template>
  <div>
    <div class="container">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="部門" label-width="50px">
              <el-select
                v-model="queryForm.dept"
                size="small"
                class="selectqry"
              >
                <el-option
                  v-for="item in myDepts"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                size="small"
                style="width: 150px"
                v-model="queryForm.qstr"
                placeholder="編號、班名、名稱、序號、備註"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-button
            v-if="!isDisableMemberManagement"
            type="primary"
            icon="el-icon-edit"
            @click="editDeptMbr"
            size="small"
            >編輯部門成員</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 部門：{{
          getDeptName(activeQueryForm.dept)
        }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :data="deptMembers"
            @sort-change="sortChange"
            :default-sort="{ prop: 'no', order: 'ascending' }"
            stripe
            style="width: 100%"
          >
            <el-table-column type="index" :index="indexFormatter" fixed>
            </el-table-column>

            <!--<el-table-column label="所屬單位/部門" prop="orgName" width="150">-->
            <!--<template #default>-->
            <!--{{ myownOrg }} /-->
            <!--{{ getDeptName(activeQueryForm.dept) }}-->
            <!--</template>-->
            <!--</el-table-column>-->

            <el-table-column
              label="人員編號"
              prop="no"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                {{ scope.row.member.no }}
              </template>
            </el-table-column>

            <el-table-column
              label="班級名稱"
              prop="className"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                {{ scope.row.member.className }}
              </template>
            </el-table-column>
            <el-table-column
              label="月光機序號"
              prop="moonlight2SerialNumber"
              width="200"
            >
              <template #default="scope">
                {{ scope.row.member.moonlight2SerialNumber }}
              </template>
            </el-table-column>
            <el-table-column
              label="人員名稱"
              prop="name"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                {{ scope.row.member.name }}
              </template>
            </el-table-column>
         <el-table-column
              label="備註"
              prop="memo"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                {{ scope.row.member.memo }}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template #default="scope">
                <el-button size="mini" @click="editMbrGrp(scope.row)"
                  >群組設定
                </el-button>

                <el-button size="mini" @click="mbrSubscribe(scope.row)"
                  >訂閱管理
                </el-button>

                <!--<el-button size="mini" disabled>審核 </el-button>-->

                <el-button
                  v-if="!isDisableMemberManagement"
                  type="danger"
                  size="mini"
                  @click="quitDept(scope.row.id)"
                  >移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>
        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>

        <EditDeptMbrDlg
          v-model="isDlgVisible"
          :deptId="activeQueryForm.dept"
          :deptName="getDeptName(activeQueryForm.dept)"
          :key="`edtDeptMbr_${dlgKey}`"
        ></EditDeptMbrDlg>

        <EditMbrGroupDlg
          v-model="isEditMbrGrpDlgVisible"
          :memberId="selectedItemId"
          :memberNo="selectMemberNo"
          :memberName="selectedMemberName"
          :deptId="activeQueryForm.dept"
          :deptName="getDeptName(activeQueryForm.dept)"
          :key="`edtMbrGrp_${editMbrGrpDlgKey}`"
        ></EditMbrGroupDlg>

        <MbrSubsMgmtDlg
          v-model="isMbrSubsDlgVisible"
          :deptMemberId="selectedItemId"
          :memberName="selectedMemberName"
          :key="`mbrSubs_${mbrSubsDlgKey}`"
        ></MbrSubsMgmtDlg>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import API from "@/api";
import { mapGetters } from "vuex";
import EditDeptMbrDlg from "@/components/dept/EditDeptMbrDlg";
import EditMbrGroupDlg from "@/components/dept/EditMbrGroupDlg";
//import MemberSubsDlg from "@/components/dept/MemberSubsDlg";
import MbrSubsMgmtDlg from "../components/dept/MbrSubsMgmtDlg";
import tagColorsMixin from "@/components/mixin/tagColors.js";
export default {
  name: "deptMemberList",
  mixins: [tagColorsMixin],
  components: {
    EditDeptMbrDlg,
    EditMbrGroupDlg,
    MbrSubsMgmtDlg,
  },
  created() {
    //console.log(`created: this.order = ${this.order}`)
    API.my.depts().then((res) => {
      //console.log('myDepts:', JSON.stringify(res.data))
      this.myDepts = res.data;
      this.queryForm.dept = res.data[0].id;
      this.activeQueryForm.dept = res.data[0].id;

      //console.log(`created: this.order = ${this.order}`)
      this.$store.commit("deptMember/CLEAR");
      this.$store.dispatch("deptMember/list", {
        max: this.pageSize,
        offset: this.offset,
        sort: this.sort,
        order: this.order,
        dept: this.queryForm.dept,
      });
      this.isDisableMemberManagement =this.myDepts.find(it=>it.id==this.queryForm.dept).isDisableMemberManagement
    });
  },
  data() {
    return {
      isDisableMemberManagement: false,
      selectedItemId: null,
      selectMemberNo: "",
      selectedMemberName: "",
      myDepts: [],
      dlgKey: 0,
      editMbrGrpDlgKey: 0,
      mbrSubsDlgKey: 0,
      isDlgVisible: false,
      isEditMbrGrpDlgVisible: false,
      isMbrSubsDlgVisible: false,
      pageSize: 50,
      currentPage: 1,
      queryForm: {
        dept: 0,
        qstr: "",
        colors: [],
      },
      activeQueryForm: {
        dept: 0,
        qstr: "",
        colors: [],
      },
    };
  },
  methods: {
    getDeptName(deptId) {
      const dept = this.myDepts.find((dept) => dept.id === deptId);
      return dept?.name ?? "";
    },
    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.query(this.pageSize, 0, this.sort, this.order, this.activeQueryForm);
      this.isDisableMemberManagement =this.myDepts.find(it=>it.id==this.queryForm.dept).isDisableMemberManagement
    },
    editDeptMbr() {
      this.isDlgVisible = true;
      this.dlgKey = this.dlgKey ? 0 : 1;
    },
    mbrSubscribe(deptMbr) {
      this.isMbrSubsDlgVisible = true;
      this.mbrSubsDlgKey = this.mbrSubsDlgKey ? 0 : 1;
      this.selectedItemId = deptMbr.id;
      this.selectedMemberName = deptMbr.member.name;
    },
    editMbrGrp(deptMbr) {
      this.editMbrGrpDlgKey = this.editMbrGrpDlgKey ? 0 : 1;
      this.selectedItemId = deptMbr.member.id;
      this.selectMemberNo = deptMbr.member.no;
      this.selectedMemberName = deptMbr.member.name;
      this.isEditMbrGrpDlgVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    query(max, offset, sort, order, params = {}) {
      this.$store.dispatch("deptMember/list", {
        max: max,
        offset: offset,
        sort,
        order,
        ...params,
      });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    quitDept(itemId) {
      //console.log(`quitDept: id = ${JSON.stringify(itemId)}`)
      this.$confirm("此操作將永久將該成員移出部門, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("deptMember/remove", itemId).then(() => {
            this.query(
              this.pageSize,
              this.offset,
              this.sort,
              this.order,
              this.activeQueryForm
            );
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {});
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("deptMember/SET_SORT", "member.no");
        this.$store.commit("deptMember/SET_ORDER", "ascending");
      } else {
        const newSort = "member." + args.prop;
        this.$store.commit("deptMember/SET_SORT", newSort);
        this.$store.commit("deptMember/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
      deptMembers: "deptMember/deptMembers",
      total: "deptMember/total",
      offset: "deptMember/offset",
      getMemberById: "deptMember/getMemberById",
      sort: "deptMember/sort",
      order: "deptMember/order",
    }),
  },
};
</script>

<style></style>
